/* import __COLOCATED_TEMPLATE__ from './signature-form.hbs'; */
import { action } from '@ember/object';
import { dismissSticky } from 'client-portal/utils/banners';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsSharedSignatureForm extends Component {
  @service session;
  @service intl;

  @action
  editSignature() {
    this._showSignatureModal(this.intl.t('signature.edit'));
  }

  @action
  sign() {
    if (this.session.signatoryName) {
      this.model.set('hasConsented', true);
    } else {
      this._showSignatureModal(this.intl.t('signature.create'));
    }
  }

  @action
  onClose() {
    this.session.currentClient.rollbackAttributes();
    this.session.currentClientAccess.client.rollbackAttributes();
    this.set('showSignatureModal', false);
  }

  _showSignatureModal(title) {
    dismissSticky();
    this.setProperties({
      title,
      showSignatureModal: true,
    });
  }
}
